import { Box, IconButton } from "@mui/material"
import { DeleteOutlined, EditOutlined } from "@mui-symbols-material/w300"
import React from "react"

interface ActionButtonsProps {
  onDelete: () => void
  onEditPaymentType?: () => void
  onEditBankDetails?: () => void
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ onDelete, onEditPaymentType, onEditBankDetails }) => (
  <Box className='flex'>
    {onEditPaymentType && (
      <IconButton color='primary' aria-label='edit payment type' onClick={onEditPaymentType}>
        <EditOutlined className='size-5 text-primary' />
      </IconButton>
    )}
    {onEditBankDetails && (
      <IconButton color='primary' aria-label='edit bank details' onClick={onEditBankDetails}>
        <EditOutlined className='size-5 text-primary' />
      </IconButton>
    )}
    <IconButton color='primary' aria-label='remove' onClick={() => onDelete()}>
      <DeleteOutlined className='size-5 text-primary' />
    </IconButton>
  </Box>
)

export default ActionButtons
